import { WidgetType, WidgetOption } from '@/types'
import input from '../input'
import WidgetDateFill from './WidgetDateFill.vue'
import DateFillSetting from './DateFillSetting.vue'
import DateFillFill from './DateFill.vue'

/** 日期填写 */
export default {
  ...input,
  key: 'date-fill',
  name: '填写日期',
  type: WidgetType.DATE_FILL,
  icon: 'fa-icon-widget-date',
  text: {
    maxLength: 11
  },
  componentExtend: WidgetDateFill,
  settingComponent: DateFillSetting,
  fillingComponent: DateFillFill
} as WidgetOption
